export const TENANTSIGNUPPAGE_SUBMIT = "TENANTSIGNUPPAGE_SUBMIT";
export const TENANTSIGNUPPAGE_SUCCESSFUL = "TENANTSIGNUPPAGE_SUCCESSFUL";
export const TENANTSIGNUPPAGE_FAILED = "TENANTSIGNUPPAGE_FAILED";
export const TENANTSIGNUPPAGE_RESET = "TENANTSIGNUPPAGE_RESET";

